<template>
  <b-card title="ผลการค้นหา">
    <!-- <div
      v-if="tabMode == 'Group'"
      class=" d-flex justify-content-end mt-n1">
      <b-form-group>
        <div class="d-flex align-items-center">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon  "
              @click="onComplainGroupManage"
            >
              <feather-icon icon="PlusCircleIcon" class="mr-50" />
              <span class="align-middle">สร้างกลุ่ม</span>
            </b-button>
        </div>
      </b-form-group>
    </div>  -->

    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength,
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <!-- Column: No -->
        <span
          v-if="props.column.field === 'No'"
          class="text-nowrap"
        >
          <span class="text-nowrap">  1 </span>
        </span>

        <!-- Column: Name -->
        <span
          v-if="props.column.field === 'Code'"
          class="text-nowrap"
        >
          <!-- <b-avatar
            :src="props.row.avatar"
            class="mx-1"
          /> -->
          <span class="text-nowrap">{{ props.row.Complain_Code_ID }}</span>
          <br>
          <span class="text-nowrap"><i class="flaticon2-open-text-book" /> 2564/32787</span>
        </span>

        <!-- Column: Name -->
        <span
          v-if="props.column.field === 'name'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{ props.row.Cusname }}</span>
          <span
            v-if="props.row.attorneyname != null"
            class="text-nowrap"
          >{{ props.row.attorneyname }}</span>
          <span
            v-else
            class="text-nowrap"
          >-</span>
        </span>
        <!-- Column: Complain_Subject -->
        <span
          v-if="props.column.field === 'detail'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{ props.row.StatusTH }}</span>
        </span>
        <!-- Column: Name -->
        <span
          v-if="props.column.field === 'Complain_Date'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{ props.row.Complain_Date }}</span>
        </span>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ props.row.status }}
          </b-badge>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <!-- <span v-if="tabMode == 'List'">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="btn-icon "
              @click="onComplainSend"
            >
              <feather-icon icon="SendIcon" class="mr-50" />
              <span class="align-middle">ส่งต่อ</span>
            </b-button>
          </span>
          <span v-else> -->
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="text-body align-middle mr-25"
                >
                  <feather-icon
                    icon="SettingsIcon"
                    class="mr-50"
                  />
                  <span class="align-middle">จัดการ</span>
                </b-button>
              </template>
              <b-dropdown-item
                @click="onComplainGroupManage"
              >
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item
                @click="confirmText"
              >
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <FileInput />
    <AttachFileList />
  </b-card>

</template>

<script>
import {
  BButton, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BCard, BCardHeader, BCardBody,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import store from '@/store/index'
import { codeBasic } from './code'
import FileInput from '../../modals/FileInput.vue'
import AttachFileList from '../../modals/AttachFileList.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    FileInput,
    AttachFileList,
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return {
      tabMode: props.mode,
    }
  },
  data() {
    return {

      pageLength: 3,
      dir: false,
      codeBasic,
      columns: [
        {
          label: 'ลำดับ',
          field: 'No',
        },
        {
          label: 'เลขร้องทุกข์',
          field: 'Code',
        },
        {
          label: 'ชื่อผู้ร้อง',
          field: 'name',
        },
        {
          label: 'สถานะ',
          field: 'detail',
        },

        {
          label: 'วันที่ดำเนินการ',
          field: 'Complain_Date',
        },
        {
          label: 'Action',
          field: 'action',
          tdClass: 'text-center',
        },
      ],
      rows: [],

      searchTerm: '',
      status: [{
        1: 'Current',
        2: 'Professional',
        3: 'Rejected',
        4: 'Resigned',
        5: 'Applied',
      },
      {
        1: 'light-primary',
        2: 'light-success',
        3: 'light-danger',
        4: 'light-warning',
        5: 'light-info',
      }],
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current      : 'light-primary',
        Professional : 'light-success',
        Rejected     : 'light-danger',
        Resigned     : 'light-warning',
        Applied      : 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    this.$http.get('/complaint/list')
      .then(res => { this.rows = res.data })
  },
  methods: {
    onComplainSend() {
      this.$emit('handleSend', '1')
    },
    onComplainGroupManage() {
      this.$emit('handleGroup', '1')
    },
    confirmText() {
      this.$swal({
        title: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        text: 'เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ลบข้อมูล',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$swal({
            icon: 'success',
            title: 'ลบข้อมูล สำเร็จ',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
}
</script>
